// File: custom-renderer.js
// Import Highway
import Highway from './highway';
import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import removeComponents from 'gia/removeComponents';
import _each from 'lodash.foreach'

import Text from './text'
import Hero from './hero'
import Contact from './contact'
import Article from './article'
import Page from './page'
import Footer from './footer'


import gsap from 'gsap'

class CustomRenderer extends Highway.Renderer {
  // Hooks/methods
  // constructor(){
  //   super()


  // }

  onEnter() {
  //  console.log('enter');
    window.scrollTo(0, 0);
  }
  onLeave() {

    $('body').removeClass('vm-loaded has-menu').addClass('vm-loading')
    removeComponents()


  }
  onEnterCompleted() {
    const components = {
      Text: Text,
      Article: Article,
      Contact: Contact,
      Page: Page,
      Footer: Footer
    }

    loadComponents(components)
    $('body').removeClass('vm-loading').addClass('vm-loaded')

  }
  onLeaveCompleted() {
    //console.log('leave complete');

  }
}

// Don`t forget to export your renderer
export default CustomRenderer;
